import React from 'react';

import {listPageClassName} from 'shared/ui/ListPage/ListPage';

import {MainLayout} from 'widgets/layout';

import {DomainMonitors} from 'features/domain';

const DomainMonitorsPage: React.FC = () => {
    return (
        <MainLayout className={listPageClassName}>
            <DomainMonitors />
        </MainLayout>
    );
};

export default DomainMonitorsPage;
